
import { defuFn } from 'defu'

const inlineConfig = {
  "nuxt": {},
  "graphqlMiddleware": {
    "clientCacheEnabled": true,
    "clientCacheMaxSize": 100
  }
}

/** client **/
import { _replaceAppConfig } from '#app/config'

// Vite - webpack is handled directly in #app/config
if (import.meta.dev && !import.meta.nitro && import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    _replaceAppConfig(newModule.default)
  })
}
/** client-end **/

import cfg0 from "/var/www/html/frontend/app/app.config.ts"

export default /*@__PURE__*/ defuFn(cfg0, inlineConfig)
